import { getIsCypressRunning } from '../helpers/getIsCypressRunning';

export const useIsCypressRunning = (): boolean => getIsCypressRunning();
